/* Tap positions for the HQ heat map (Aditya, 2026-11-04, side fallback 07:50: "an actual click
   heat map ... the number of clicks on that page itself, irrespective of the
   position of the articles"). Every pointer-up anywhere on the page is sent
   to dashboard.tenzen.in with where it landed (x as a share of the viewport
   width, y on the page in px), the viewport, the page height, which part of
   the page it hit and the A/B side. Batched; sent with sendBeacon when the
   page is hidden, so nothing waits on the network. No cookies, no ids
   beyond a per-page random session number. Never touches cart or checkout. */
(function () {
  'use strict';
  if (window.__tzTap) return;
  window.__tzTap = true;
  var doc = document, html = doc.documentElement;
  var URL = 'https://dashboard.tenzen.in/api/taps';
  var col = doc.querySelector('.v-col[data-collection][data-handle]');
  var pdp = doc.querySelector('.v-pdp[data-product-handle]');
  var page = pdp ? 'product' : col ? (col.getAttribute('data-handle') === 'fall-winter-2026' ? 'collection' : 'category') : (location.pathname === '/' ? 'home' : 'other');
  if (page === 'other') return;
  var sid = Math.floor(Math.random() * 1e9);
  var FAM = [
    ['[data-notify-open]', 'notify'], ['a.v-card', 'card'], ['.v-col__pill', 'filter_pill'], ['.v-refine-dock__btn', 'dock'],
    ['.v-col__banner-art, .v-col__lede-title, .v-col__lede-artist, .v-col__lede-meta', 'album'],
    ['.v-crail__card, a.v-tcards__card', 'category_card'], ['.v-hero-banner__slide', 'hero'], ['.v-frail__banner', 'rail_banner'],
    ['.tz-gender__btn', 'gender'], ['.tz-album', 'album_tile'], ['.v-pdp__model-stage', 'stage'], ['.v-pdp__media-item', 'photo'],
    ['[data-pdp-minimap]', 'strip'], ['[data-pdp-rating-link], [data-crev-jump]', 'rating'], ['[data-pdp-swatch]', 'swatch'],
    ['[data-pdp-atc]', 'atc_add'], ['[data-pdp-sheet-plus], [data-pdp-open-sizes]', 'atc_main'], ['[data-pdp-sheet-toggle]', 'sheet_toggle'],
    ['[data-open-size-chart]', 'size_guide'], ['[data-pdp-emi-open]', 'emi'], ['[data-trust-open]', 'trust'],
    ['.v-pdp__acc-summary, [data-pdp-desc-toggle]', 'accordion'], ['[data-rec-list]', 'recs'], ['.v-looks__photo-link, [data-look-dot], .v-looks__card-media', 'look'],
    ['.tz-tab', 'tab'], ['.tz-fab, [data-pdp-fab]', 'fab'], ['[data-open-search]', 'search'], ['[data-open-cart], [data-tz-bag]', 'bag'],
    ['[data-tz-back]', 'back'], ['[data-tz-share]', 'share'], ['footer a, .v-footer a', 'footer'], ['a[href], button', 'other']
  ];
  var handleOf = function (href) { var m = /\/(?:products|collections)\/([a-z0-9-]+)/i.exec(href || ''); return m ? m[1] : ''; };
  var side = function () { var ab = html.getAttribute('data-ab-fw'); if (!ab) { try { ab = localStorage.getItem('tz:ab_fw') || ''; } catch (e) { ab = ''; } } return ab; };
  var part = function (t) {
    if (!t || !t.closest) return ['', ''];
    for (var i = 0; i < FAM.length; i++) {
      var el = t.closest(FAM[i][0]);
      if (!el) continue;
      var label = handleOf(el.getAttribute('href')) || el.getAttribute('data-notify-handle') || (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 40);
      return [FAM[i][1], label];
    }
    return ['', ''];
  };
  var buf = [];
  var flush = function () {
    if (!buf.length) return;
    var body = JSON.stringify({ s: sid, p: page, c: col ? col.getAttribute('data-handle') : '', h: pdp ? pdp.getAttribute('data-product-handle') : '', v: side(), taps: buf });
    buf = [];
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(URL, new Blob([body], { type: 'text/plain' }))) return;
      fetch(URL, { method: 'POST', body: body, keepalive: true, mode: 'cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    } catch (e) { /* never breaks the page */ }
  };
  var timer = null;
  doc.addEventListener('pointerup', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    var pr = part(e.target);
    buf.push({ x: +(e.clientX / Math.max(1, window.innerWidth)).toFixed(4), y: Math.round(e.clientY + window.scrollY), w: window.innerWidth, vh: window.innerHeight, dh: html.scrollHeight, f: pr[0], l: pr[1], st: doc.body.getAttribute('data-pdp-sheet-state') || '', t: Date.now() });
    if (buf.length >= 20) flush();
    else { clearTimeout(timer); timer = setTimeout(flush, 4000); }
  }, { capture: true, passive: true });
  doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'hidden') flush(); });
  window.addEventListener('pagehide', flush);
})();
